/* Translate Shopify system filter labels to Dutch.
   These labels come from Shopify's Storefront API and don't respect
   theme locale files. This script patches them client-side. */
(function () {
  var translations = {
    'Availability': 'Beschikbaarheid',
    'Price': 'Prijs',
    'Color': 'Kleur',
    'Size': 'Maat',
    'Material': 'Materiaal',
    'Brand': 'Merk',
    'Product type': 'Producttype',
    'Vendor': 'Leverancier',
    'In stock': 'Op voorraad',
    'Out of stock': 'Niet op voorraad'
  };

  function translateFilters() {
    document.querySelectorAll(
      '.facets__summary-label, .mobile-facets__sort-label, .facets__heading, [class*="facet"] span, .active-facets__button-inner'
    ).forEach(function (el) {
      var text = el.textContent.trim();
      if (translations[text]) {
        el.textContent = translations[text];
      }
      /* Handle "Label: Value" pattern in active filters */
      Object.keys(translations).forEach(function (key) {
        if (text.startsWith(key + ':')) {
          el.textContent = text.replace(key + ':', translations[key] + ':');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', translateFilters);
  } else {
    translateFilters();
  }

  /* Re-translate after facet updates (Shopify re-renders filter UI via AJAX) */
  var observer = new MutationObserver(function (mutations) {
    translateFilters();
  });

  var facetContainer = document.getElementById('FacetFiltersForm') ||
    document.getElementById('FacetsWrapperDesktop') ||
    document.querySelector('.facets-container');

  if (facetContainer) {
    observer.observe(facetContainer, { childList: true, subtree: true });
  }
})();
